/**
 * Brand tokens — single source of truth for color, fonts, and typography.
 * Mirrored from Docs/IMPLEMENTATION_PLAN_AWS.md §22 and the live
 * fixitninjaz.com site (verified via <meta name="theme-color">).
 */

export const BRAND = {
  name: 'Fix It Ninjaz',
  shortName: 'FixItNinjaz',
  domain: 'fixitninjaz.com',

  /** Primary deep ninja green — pulled from live site theme-color */
  primary: '#0F2D1F',
  /** Lighter primary surface for hover / chips */
  primarySoft: '#1B4A33',
  /** Orange accent (CTA, urgent badges) */
  accent: '#F97316',
  /** Warning (urgent jobs, SLA breach) */
  warning: '#F59E0B',
  /** Danger (cancellations, errors) */
  danger: '#DC2626',
  /** Success (completed jobs, paid invoices) */
  success: '#16A34A',

  /** Neutral surface tokens */
  surface: '#FFFFFF',
  surfaceMuted: '#F5F5F4',
  border: '#E7E5E4',
  text: '#1C1917',
  textMuted: '#57534E',

  fonts: {
    sans: '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    arabic: '"Noto Sans Arabic", "IBM Plex Sans Arabic", "Inter", sans-serif',
  },
} as const;

export type BrandTokens = typeof BRAND;
